import { Realm as RealmFields } from '@/generated/graphql';
import { UserCurrentFields } from '@/components/provider/UserCurrentProvider';

/**
 * Filters the navigation tree based on user roles and ownership.
 * content_authors only see their own unpublished content.
 * Higher roles see all unpublished content.
 */
export const filterNavigationData = (
    realms: RealmFields[],
    userCurrent?: UserCurrentFields,
): RealmFields[] => {
    // If not an editor, we assume the backend handles public visibility
    if (!userCurrent?.isContentEditor) {
        return realms;
    }

    const isElevatedEditor = userCurrent.roles.some((role) =>
        ['content_manager', 'content_administrator', 'content_mentor'].includes(
            role,
        ),
    );

    return realms.map((realm) => ({
        ...realm,
        zones: realm.zones
            .map((zone) => ({
                ...zone,
                matrices: zone.matrices.filter((matrix) => {
                    if (matrix.published || isElevatedEditor) return true;
                    return matrix.owner?.id === userCurrent.id;
                }),
            }))
            .filter((zone) => {
                const hasVisibleContent = zone.matrices.length > 0;
                if (zone.published || isElevatedEditor) return true;

                const isZoneOwner = zone.owner?.id === userCurrent.id;
                return isZoneOwner || hasVisibleContent;
            }),
    }));
};
